module.exports = __webpack_public_path__ + "static/media/cover.2e6ef579.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/FranzEliza/cover.png
// module id = 145
// module chunks = 0